import React from "react";
import PSPage from "components/globals/ui/layout/Page";
import { useFetchData } from "helpers/utils";
import { useParams } from "react-router-dom";
import PSGrid from "components/globals/ui/Grid";
import Card from "components/globals/ui/Card";
import SearchForm from "components/globals/SearchForm";
import {
  PSCollapsableContainer,
  PSCollapsableContainerHeading,
  PSCollapsableContainerContent,
} from "components/globals/ui/PSCollapsableContainer";

export default function Search() {

	const { query } = useParams();

	const { data: entries, loading, error } = useFetchData(
		`${process.env.REACT_APP_SERVER_URI}/api/search/${query}`,
		[query],
	);

	return (
		<>
			<div className="bg-[#303030] text-white py-sm md:py-md">
				<div className="max-w-[500px] px-xs text-center mx-auto">
					<h2 className=" text-[26px]">Search Results for: {query}</h2>
					<SearchForm />

					{entries && (
						<div className="flex items-center gap-3 justify-center mt-sm">
							<a href="#posts" className="inline-block bg-black text-white rounded-lg py-2 px-xs">Posts <span className="">({entries?.posts?.length})</span></a>
							<a href="#articles" className="inline-block bg-black text-white rounded-lg py-2 px-xs">Articles <span className="">({entries?.articles?.length})</span></a>
							<a href="#cars" className="inline-block bg-black text-white rounded-lg py-2 px-xs">Cars <span className="">({entries?.cars?.length})</span></a>
							<a href="#events" className="inline-block bg-black text-white rounded-lg py-2 px-xs">Events <span className="">({entries?.events?.length})</span></a>
						</div> 
					)}
				</div>
			</div>

			<PSPage>

				{entries && (
					<>
						<div id="posts" className="mt-sm">
							<PSCollapsableContainer startShown>
								<PSCollapsableContainerHeading>
									<h3 className="py-xs  text-[20px] md:text-[26px]"> Posts ({entries?.posts?.length})</h3>
								</PSCollapsableContainerHeading>
								<PSCollapsableContainerContent>
									<Results type="post" entries={entries?.posts} />
								</PSCollapsableContainerContent>
							</PSCollapsableContainer>
						</div>

						<div id="articles" className="mt-sm">
							<PSCollapsableContainer startShown>
								<PSCollapsableContainerHeading>
									<h3 className="py-xs  text-[20px] md:text-[26px]"> Articles ({entries?.articles?.length})</h3>
								</PSCollapsableContainerHeading>
								<PSCollapsableContainerContent>
									<Results type="article" entries={entries?.articles} />
								</PSCollapsableContainerContent>
							</PSCollapsableContainer>
						</div>

						<div id="cars" className="mt-sm">
							<PSCollapsableContainer startShown>
								<PSCollapsableContainerHeading>
									<h3 className="py-xs  text-[20px] md:text-[26px]"> Cars ({entries?.cars?.length})</h3>
								</PSCollapsableContainerHeading>
								<PSCollapsableContainerContent>
									<Results type="car" entries={entries?.cars} />
								</PSCollapsableContainerContent>
							</PSCollapsableContainer>
						</div>

						<div id="events" className="mt-sm">
							<PSCollapsableContainer startShown>
								<PSCollapsableContainerHeading>
									<h3 className="py-xs  text-[20px] md:text-[26px]"> Events ({entries?.events?.length})</h3>
								</PSCollapsableContainerHeading>
								<PSCollapsableContainerContent>
									<Results type="event" entries={entries?.events} />
								</PSCollapsableContainerContent>
							</PSCollapsableContainer>
						</div>
					</>
				)}
			</PSPage>
		</>
	);
};


const Results = ({ entries, type }) => {

	const displayOptions = {
		yoursBadge: true,
		userBadge: true,
		typeBadge: false,
		categoryBadge: true,
		carBadge: true,
		carDetails: true,
		dateDetails: true,
		likes: true,
	}

	return (
		<PSGrid mobileCarousel={displayOptions.mobileCarousel}>
			{entries?.map((entry, index) => (
				<Card
					key={`${entry.internal_id || entry.user_id}-${index}`}
					item={entry}
					path={type}
					displayOptions={displayOptions}
					id={`item-${entry.internal_id || entry.user_id}`} 
				/>
			))}
	</PSGrid>
	)
}